<template>
  <ul
    v-if="items"
    :style="[
      items.length > 1
        ? { columns: 1, 'column-gap': '20px', 'margin-bottom': '0px' }
        : '',
    ]"
  >
    <li v-for="(item, index) in slicedItems" :key="item.id">
      <slot name="item" :item="item" :index="index" />
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { Category } from '@scayle/storefront-nuxt'

type OneColumnListProps = {
  items: Category[] | undefined
  slice?: 3 | 4 | 5 | 6 | 7
  filter?: (item: Category) => boolean
}

const props = withDefaults(defineProps<OneColumnListProps>(), {
  slice: 4,
  filter: () => () => true,
})

const itemsLength = props.slice
const filteredItems = computed(
  () => props.items?.filter((item) => props.filter!(item)) || [],
)
const slicedItems = computed(() => filteredItems.value.slice(0, itemsLength))
</script>
